export const environment = {
  production: true,
  env: "prod",
  polarisRuntimeStrategy: 'migration',
  baseUrl: "https://insights-console-server.browsi.com",
  auth0Domain: "auth.browsi.com",
  auth0ClientId: 'bzp0YCNWlqjFWlutTsKDYIpPGcUWMaIK',
  authAudience: 'https://insighthub.browsi.com/',
  posthogKey: "phc_IhJiIwqyk1KJQciLEbxErasowz99jUgVsw2qnPY8r94",
  posthogHost: "https://us.i.posthog.com",
  posthogApiHost: "https://at.browsi.com",
  appVersion: '3.27.3329',
  hubspotBaseUrl: 'https://api.hsforms.com',
  hubspotPortalId: '6872156',
  hubspotStepOneFormId: 'ad7dab15-a246-4c6d-9f6a-819bb21fa14c',
  hubspotStepThreeFormId: '34651167-b7a6-4c76-bd85-0b58dacb1f85',
  gtmId: 'GTM-MQCKXJF5',
  gtmAuth: '',
  gtmPreview: ''
};
